import { useMutation, useQueryClient } from '@tanstack/react-query';

import { offboardUser } from '~/services/AgentHub/AgentService';

export function useOffboardUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: string) => {
      return await offboardUser(userId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['list-eoi'] });
    },
  });
}
